export default "__VITE_ASSET__22d06ead__"